import * as React from 'react';

import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';
import { CONTACTS_DEFAULT_SORT } from '../../../sic-lib/defaults';
import { useAppSelector } from '../../../store/hooks';
import MenuContactsSortRaw from './MenuContactsSortRaw/MenuContactsSortRaw';

const useStyles = makeStyles()({
    button: {
        padding: '10px',
    },
});

interface Props {
    viewId: number;
}

export default function MenuContactsSort({ viewId }: Props) {
    const { classes } = useStyles();

    const appliedSort = useAppSelector(state => {
        return state.conversationGrid?.sortField || CONTACTS_DEFAULT_SORT;
    });

    const [hasSort, setHasSort] = React.useState<boolean>(false);

    React.useEffect(() => {
        const checkHasSort =
            appliedSort.direction !== CONTACTS_DEFAULT_SORT.direction ||
            appliedSort.fieldId !== CONTACTS_DEFAULT_SORT.fieldId;

        setHasSort(checkHasSort);
    }, [appliedSort]);

    const [menuId] = React.useState<string>('menu_table_contacts_sort');

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Tooltip title="Sort">
                <IconButton
                    onClick={handleOpen}
                    aria-haspopup="true"
                    aria-controls={menuId}
                    aria-expanded={Boolean(anchorEl)}
                    color={hasSort ? 'secondary' : 'default'}
                    className={classes.button}
                    size="large"
                >
                    <SortByAlphaIcon />
                </IconButton>
            </Tooltip>
            {Boolean(anchorEl) && (
                <MenuContactsSortRaw
                    viewId={viewId}
                    anchorEl={anchorEl}
                    menuId={menuId}
                    onCloseHandler={handleClose}
                />
            )}
        </React.Fragment>
    );
}
